import styled from "styled-components";
import { theme } from "@themes";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.border.light};
  position: relative;
`;

export const LogoTPHome = styled.img`
  position: absolute;
  left: 20px;
  width: 170px;
  @media only screen and (max-width: 700px) {
    width: 100px;
    height: 35px;
  }
`;

export const LoginButton = styled.button`
  padding: 6px 16px;
  border-radius: 6px;
  border: none;
  background: ${({ theme }) => theme.neutral.gray[3500]};
  color: white;
  cursor: pointer;
  transition: 0.2s;
  font-size: 14px;
  &:hover {
    background: ${({ theme }) => theme.neutral.black};
  }
`;
